import type { EnhancedStore } from '@reduxjs/toolkit';
import type { RootState } from './rootReducer';
import type { AppDispatch } from './types';

type AppStore = EnhancedStore<RootState> & { dispatch: AppDispatch };

let appStore: AppStore | undefined;

export const setAppStore = (store: EnhancedStore<RootState>): void => {
  appStore = store as AppStore;
};

/** Access the Redux store from modules that cannot import store.tsx (circular deps). */
export const getAppStore = (): AppStore => {
  if (!appStore) {
    throw new Error('Redux store has not been initialized');
  }
  return appStore;
};
